const BID = (function () {
    let modules = {};

    return modules;
});

$(document).ready(function () {
    $(document).on('change', '#form-search-bids .select-sort', function () {
        $('#form-search-bids .btn-search').trigger('click');
    })
});
